import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectUserRoles = createSelector(
  [
    (store: RootState) => store.locationShow.userRoles,
    (store: RootState) => store.locationShow.userRolesSearchText,
  ],
  (data, searchText) =>
    [...(data || [])]
      .filter(({ user: { name = "" } }) =>
        name.toLowerCase().includes((searchText || "").toLowerCase())
      )
      .sort((a, b) => {
        if ((a.user?.name || "") > (b.user?.name || "")) {
          return 1;
        }
        return -1;
      })
);
